"use client";
import { useLocale } from "next-intl";
import Image from "next/image";
import { usePathname, useRouter } from "next/navigation";

import React from "react";

const flagMatcher = {
  ru: "/ru.png",
  en: "/en.png",
};

const ChangeLanguage = () => {
  const locale = useLocale();
  const path = usePathname();
  const router = useRouter();

  const changeLang = (l: string) => {
    if (locale !== l) {
      let splittedPath = path.split("/");
      const pathLang = splittedPath[0];
      splittedPath[1] = l;
      const correctPath = splittedPath.join("/");
      router.push(correctPath);

    }
  };
  return (
    <span className="flex gap-2 border-[1px] shadow-2xl p-1">
   {/*    <div className="relative w-12 h-8 shadow-lg border-2 overflow-hidden">
        {" "}
        <Image
          fill
          alt=""
          // @ts-ignore
          src={flagMatcher[locale]}
        />
      </div> */}
      <select
        value={locale}
        className="px-2"
        onChange={(e) => {
          changeLang(e.target.value);
        }}
      >
        <option value={"en"}>EN</option>
        <option value={"ru"}>RU</option>
      </select>
    </span>
  );
};

export default ChangeLanguage;
